import { Components, Theme } from "@mui/material";

export const MuiFormControl: Components<Theme>["MuiFormControl"] = {
  styleOverrides: {
    root: ({ theme }) => ({ backgroundColor: theme.newColors.neutral.white }),
  },
};
